export const OAUTH_PROVIDER_LINE = 'LINE';
export const OAUTH_PROVIDER_FACEBOOK = 'FACEBOOK';
export const OAUTH_PROVIDER_ACCOUNTKIT = 'ACCOUNTKIT';
export const OAUTH_PROVIDER_EMAIL = 'EMAIL';

export const OAUTH_PROVIDER_DISPLAY_NAME = Object.freeze({
  [OAUTH_PROVIDER_LINE]: 'LINE',
  [OAUTH_PROVIDER_FACEBOOK]: '臉書',
  [OAUTH_PROVIDER_ACCOUNTKIT]: '手機',
  [OAUTH_PROVIDER_EMAIL]: '信箱',
});

export const AUTH_TYPE_SIGNIN = 'signin';
export const AUTH_TYPE_SIGNUP = 'signup';
export const VALID_AUTH_TYPES = Object.freeze([AUTH_TYPE_SIGNIN, AUTH_TYPE_SIGNUP]);
export const AUTH_ERROR_CODE_ACCOUNT_NOT_FOUND = 1001;
export const AUTH_ERROR_ACCOUNT_NOT_FOUND = 'AUTH_ERROR_ACCOUNT_NOT_FOUND';
export const AUTH_ERROR_ANY = 'AUTH_ERROR_ANY';
